import type { OptaTeamStanding } from '@sportworld/js-sdk/src/types/soccerDataTypes'

import { renderPoints, teamRender } from './partials'
import type { Columns, ColumnsWithoutData } from './types'

export const STANDINGS_LEAGUE_COLUMNS: Columns<OptaTeamStanding> = [
  {
    title: 'dataWidget.standing.pl',
    width: 60,
    render: (team) => team.rank,
  },
  {
    title: 'dataWidget.standing.team',
    width: 316,
    render: teamRender,
  },
  {
    title: 'dataWidget.standing.mp',
    width: 50,
    render: (team) => team.matchesPlayed,
  },
  {
    title: 'dataWidget.standing.w',
    width: 50,
    render: (team) => team.matchesWon,
  },
  {
    title: 'dataWidget.standing.d',
    width: 50,
    render: (team) => team.matchesDrawn,
  },
  {
    title: 'dataWidget.standing.l',
    width: 50,
    render: (team) => team.matchesLost,
  },
  {
    title: 'dataWidget.standing.goals',
    width: 80,
    render: (team) => `${team.goalsFor}:${team.goalsAgainst}`,
  },
  {
    title: 'dataWidget.standing.gd',
    width: 50,
    render: (team) => team.goaldifference,
  },
  {
    title: 'dataWidget.standing.pts',
    width: 70,
    render: (team) => team.points,
    accent: true,
  },
]

export const STANDINGS_GROUPS_COLUMNS: Columns<OptaTeamStanding> = [
  {
    title: 'dataWidget.standing.pl',
    width: 100,
    render: (team) => team.rank,
  },
  {
    title: 'dataWidget.standing.team',
    width: 320,
    render: teamRender,
  },
  {
    title: 'dataWidget.standing.mp',
    width: 160,
    render: (team) => team.matchesPlayed,
  },
  {
    title: 'dataWidget.standing.w',
    width: 50,
    render: (team) => team.matchesWon,
  },
  {
    title: 'dataWidget.standing.d',
    width: 50,
    render: (team) => team.matchesDrawn,
  },
  {
    title: 'dataWidget.standing.l',
    width: 50,
    render: (team) => team.matchesLost,
  },
  {
    title: 'dataWidget.standing.goals',
    width: 210,
    render: (team) => `${team.goalsFor}:${team.goalsAgainst}`,
  },
  {
    title: 'dataWidget.standing.gd',
    width: 80,
    render: (team) => team.goaldifference,
  },
  {
    title: 'dataWidget.standing.pts',
    width: 190,
    render: renderPoints,
    accent: true,
  },
]

export const MATCHES_COLUMNS: ColumnsWithoutData = [
  { title: '', width: 732 },
  { title: '', width: 120 },
  { title: '', width: 732 },
]

export const MATCHES_COMMENTARY_COLUMNS: ColumnsWithoutData = [
  { title: '', width: 80 },
  { title: '', width: 190 },
  { title: '', width: 1080 },
  { title: '', width: 128 },
]
